// extracted by mini-css-extract-plugin
module.exports = {"saveForLater":"_3R1Ft"};